import { TableProps } from 'core/table/table.props';

export const TablePresets: TableProps = {
  columns: [],
  data: [],
};
